<div *ngIf="message" class="alert alert-danger" role="alert">
  {{message}}
</div>
